const CRUMB_KEY = 'X-CSRF-Token';
const CLIENT_ERROR_LOGGING_ENDPOINT = '/lodging/docs/api/errors';

module.exports = {
    CLIENT_ERROR_LOGGING_ENDPOINT,
    CRUMB_KEY,
};
